var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isEnabled)?_c('div',{staticClass:"info-bar",attrs:{"role":"status"}},[_c('font-awesome-icon',{staticClass:"info-bar-icon",attrs:{"icon":"info-circle"}}),_c('span',{staticClass:"info-bar-text"},[_vm._v(_vm._s(_vm.text))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }